module.exports = __webpack_public_path__ + "static/img/1.c3c751a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/1.jpg
// module id = VDP/
// module chunks = 1